const isSantander = (organizationName?: string) => (
  organizationName?.toLowerCase() === "santander"
);

export default isSantander;
